let subCategoryData = [
    {
        id: 'c1-1',
        name: 'All',
        urlName: 'football+all',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-2',
        name: 'Accessories',
        urlName: 'accessories',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-3',
        name: 'Blasters',
        urlName: 'blasters',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD1.jpg?alt=media&token=ba845393-9fe1-4dc0-bc37-c5de62740b89'
    },{
        id: 'c1-4',
        name: 'Chutes',
        urlName: 'chutes',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ1.jpg?alt=media&token=2f752ef2-17a1-40e7-b718-95f156c13cf7'
    },{
        id: 'c1-5',
        name: 'Dummies',
        urlName: 'dummies',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fhalf-round-dummies-HQ1.jpg?alt=media&token=f0ef0bfb-b129-4935-b987-106a395237a9'
    },{
        id: 'c1-6',
        name: 'Field Accessories',
        urlName: 'field',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-7',
        name: 'Practice Items',
        urlName: 'practice items',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-8',
        name: 'Sleds',
        urlName: 'sleds',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-9',
        name: 'Strength & Speed',
        urlName: 'strength and speed',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-10',
        name: 'Training',
        urlName: 'training',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    },{
        id: 'c1-11',
        name: 'Youth Football',
        urlName: 'youth football',
        main: 'Football',
        coverImg: 'https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fimage-coming-soon.jpg?alt=media&token=e4f1e90a-0052-459f-829c-57c5471e3415'
    }
]

export default subCategoryData